const Loader = (props) => {
    return (
        <div className={`loadWrapper ${props.className || ''}`} style={props.style}>
            <div className="site-loader-text" style={props.textStyle}>Loading...</div>
        </div>
    )
}

export default Loader;